import {MaintenanceNotification, maintenanceNotifications} from '@hconnect/common/types'
import {RemoveFilterButton} from '@widgets/common-filters'
import React from 'react'

import {FilterDropDown} from './FilterDropDown'
import type {CommonFilterDropDownProps} from './FilterDropDown'

export const MaintenanceNotificationFilterDropdown: React.FC<
  CommonFilterDropDownProps<MaintenanceNotification>
> = (props) => {
  return (
    <FilterDropDown
      {...props}
      options={maintenanceNotifications}
      keyName="maintenanceNotificationExists"
      fullWidth={false}
      customDropDownFooter={(keyName) => {
        return props.isCollapsible ? null : (
          <RemoveFilterButton keyName={keyName} removeFilter={props.removeFilter} />
        )
      }}
    />
  )
}
